// extracted by mini-css-extract-plugin
export default {"profile-table":"editUser_profile-table__EDGkf","dropdown-disabled":"editUser_dropdown-disabled__xtwph","no-data-cloud-invoice":"editUser_no-data-cloud-invoice__BJ0kT"};